<app-label-inflator
  #labelCalculator
  hidden
  class="label-calculator"
  [calculateVirtualLabel]="true"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>
<div class="main-section">
  <div class="top-container">
    <div class="brand-section">
      <div class="brush-stroke">
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          height="100%"
          viewBox="0 0 500 491.55"
          [style.fill]="(viewModel.cardAccentColor$ | async) || '#ce8e72'">
          <path
            class="cls-1"
            d="M379.54,58.35c22.18,12.15,42.31,28.45,58.81,47.26,8.32,9.37,15.78,19.27,22.31,29.5,6.53,10.3,12.34,20.73,17.1,31.42-7.79-16.96-17.49-33-28.84-47.66,8.51,11.02,15.25,22.05,20.79,33.66,5.61,11.62,10.03,23.89,13.33,37.62-1.32-1.78-2.51-4.22-3.7-7-1.19-2.71-2.51-5.61-3.76-8.38-1.19-2.84-2.57-5.41-3.89-7.46-1.32-2.11-2.57-3.63-3.83-4.22-14.26-29.83-33.99-57.1-58.28-79.87-24.22-22.77-53.27-40.73-84.82-51.95,13.86-.13,24.09,4.62,32.21,10.36,8.25,5.61,14.59,12.21,22.57,16.77" />
          <path
            class="cls-1"
            d="M490.56,263.5c-.13-3.3-.26-6.6-.4-9.83-.07-3.23-.46-6.47-.66-9.64.99,6.73,1.39,13.47,1.06,19.47" />
          <path class="cls-1" d="M56.77,214.26c-1.12,6.6-1.98,13.2-2.77,19.6.13-6.53,1.32-13.07,2.77-19.6" />
          <path
            class="cls-1"
            d="M293.53,46.86c-3.76-.07-7.59,0-11.35-.07-28.05-4.16-57.43-3.17-86.34,3.76,15.64-3.96,32.01-7.39,48.65-8.51,16.63-1.12,33.53.13,48.98,4.88" />
          <path
            class="cls-1"
            d="M321.25,61.25c13.47,4.09,26.47,10.1,38.22,17.56,11.82,7.46,22.38,16.44,31.16,26.2-18.09-19.08-42.38-34.46-69.37-43.76" />
          <path
            class="cls-1"
            d="M136.5,375.25c.46-.53,1.12-.59,1.85-.46.59.33,1.19.59,1.78.66,5.35,6.86,11.22,13.4,17.62,19.47-1.91-1.06-4.36-1.32-6.14-2.64-1.72-1.72-2.9-3.37-3.96-4.82-1.06-1.45-1.91-2.71-2.77-4.09-.86-1.32-1.85-2.57-3.23-3.83-1.32-1.25-2.9-2.77-5.21-4.29" />
          <path
            class="cls-1"
            d="M58.42,207.06s-.13-.53-.13-.79c.46-2.24.86-4.49,1.45-6.67.13-.26.26-.46.46-.73-.59,2.71-1.19,5.41-1.78,8.12" />
          <path
            class="cls-1"
            d="M129.44,366.6c.92-.92,1.78-1.91,2.18-3.17,1.25,2.11,2.71,4.03,4.09,6.07,1.32,2.05,2.9,3.96,4.36,5.87-.59-.2-1.19-.46-1.72-.53-.73-.46-1.45-1.06-2.18-1.72-.66-.73-1.32-1.58-2.05-2.38-1.39-1.65-2.97-3.17-4.69-4.09" />
          <path
            class="cls-1"
            d="M103.17,262.71c0-2.97-2.57-5.68-3.23-7.19,2.24-7.72,4.82-15.18,7.66-23.76-.33-1.52.2-4.36-.4-7.46,1.52-1.32,2.84-2.77,4.09-4.36-5.94,18.61-8.58,39.01-7.26,60.07-.4-2.77-.59-5.61-.86-8.51,0-2.9-.13-5.87,0-8.84" />
          <path
            class="cls-1"
            d="M447,268.32c.4,8.25-.59,16.83-2.11,25.35-1.65,8.58-4.09,17.03-6.93,25.35-5.81,16.63-13,32.21-18.81,47.66,6.01-7.46,11.95-16.17,16.9-25.48,5.02-9.31,9.31-18.94,12.87-27.92,7-17.95,11.22-33.07,17.16-35.78,2.97-1.32,4.29,1.52,4.49,7.26,0,2.84-.33,6.4-.92,10.43-.66,4.03-1.65,8.45-2.9,13.2-2.51,9.44-6.47,19.67-10.76,29.31-4.36,9.64-9.17,18.48-12.87,25.74,2.02-2.2,4.07-4.42,6.14-6.67-3.17,3.37-6.01,6.67-6.8,10.63,1.65-1.58,3.43-3.7,5.28-6.01,1.85-2.31,3.89-4.82,5.68-7.26,1.85-2.44,3.76-4.82,5.35-6.8,1.65-1.98,3.17-3.56,4.49-4.42-.13,2.84-.26,5.68-.53,8.58,8.58-9.04,16.83-24.55,22.84-41.25,6.07-16.63,9.9-34.19,14.26-46.8-6.93,30.76-17.23,62.31-33.47,92.08-8.05,14.92-17.56,29.31-28.38,42.97-10.96,13.53-23.37,26.27-37.03,37.69-13.73,11.42-28.91,21.39-45.02,29.77-16.17,8.32-33.4,14.72-51.16,19.08-17.76,4.42-36.04,6.47-54.13,6.53-18.09,0-36.17-2.05-53.33-6.4-19.41-4.29-38.22-10.36-55.91-18.61-8.91-3.96-17.43-8.71-25.87-13.53-8.25-5.08-16.44-10.36-24.09-16.24-7.79-5.74-15.05-12.15-22.24-18.68-6.93-6.67-13.8-13.6-20-20.99-12.54-14.72-23.7-30.69-32.74-47.79-3.04-6.6-7.26-18.28-9.9-31.75-2.77-13.4-4.22-28.32-4.42-40.73-2.05-21.85-1.39-44.09,1.85-66.14.99-5.48,1.72-11.02,2.97-16.44l1.78-8.18,2.11-8.12,1.06-4.09,1.19-4.03,2.44-8.05,2.77-7.99c.92-2.71,1.85-5.35,2.9-7.92,4.69-11.09,10.56-21.52,16.9-31.62,6.47-10.03,13.8-19.54,21.72-28.51,15.97-17.76,34.52-33.27,55.12-45.81C155.84,14.72,204.62.86,255.58,0c5.08,0,10.63.79,15.18,1.98,4.62,1.39,8.25,3.17,9.7,4.88,1.45,1.72.73,3.37-3.37,4.55-2.05.59-4.88,1.06-8.71,1.45-3.83.59-8.65.79-14.59,1.32-19.6,2.18-38.94,6.01-57.69,11.62-18.75,5.68-36.9,13.2-54.19,22.31.59-1.32,2.11-2.71,4.22-4.16,1.06-.73,2.24-1.45,3.5-2.24,1.32-.73,2.71-1.39,4.09-2.11,5.68-2.97,12.01-5.61,15.64-8.38-14.13,4.09-26.6,9.37-38.42,15.71-11.82,6.4-22.97,13.86-34.06,23.23,14.79-12.54,30.96-23.37,48.25-32.28-21.58,11.09-42.9,25.61-61.52,43.83-18.81,18.02-34.79,39.74-46.47,63.37-4.36,8.58-10.83,15.51-16.17,24.42-5.54,8.71-9.9,19.6-9.31,33.99,5.08-16.63,11.88-32.81,20.26-48.05,8.45-15.25,18.42-29.57,29.64-42.77,22.51-26.4,49.9-48.32,80.33-64.55l-.2.4c13.47-7.46,27-13.2,40.86-17.49,13.86-4.36,27.99-7.39,42.64-9.37-2.24.46-4.55.79-6.8,1.32-2.24.53-4.49.99-6.67,1.52-4.42.86-8.65,1.98-12.67,2.57l7.99-1.25,7.99-.92c5.28-.73,10.63-.92,15.97-1.39,10.63-.46,21.19-.66,31.68,0,10.5.46,20.92,1.85,31.22,3.56,5.15,1.06,10.3,1.91,15.38,3.23,2.51.66,5.08,1.25,7.59,1.91l7.52,2.24c-29.11-5.48-59.21-6.8-88.91-3.04-29.77,3.63-59.21,12.48-86.14,26.53-26.86,13.99-51.09,33.2-70.36,56.24-19.34,22.97-33.66,49.7-41.52,77.49,7.79-14.46,14.79-31.62,23.89-47.39,9.11-15.71,20.26-29.9,32.48-37.29-8.98,9.31-17.16,19.34-24.55,30.03-7.33,10.69-13.8,22.05-19.41,33.86-11.09,23.7-18.42,49.5-21.06,76.17-.13-4.03-.33-7.92-.4-11.88-4.16,16.37-4.62,34.06-2.71,51.35,1.91,17.36,6.27,34.32,11.22,50.43.86,2.9,1.65,5.81,2.71,8.65-.99-2.84-1.78-5.74-2.71-8.65-8.71-29.83-11.09-60.53-8.12-89.97.46,13.66.46,27.85,1.91,45.08.53-4.75.99-10.43,1.25-16.57.46-6.14.79-12.74,1.58-19.27.73-17.23,3.37-34.46,8.25-50.76-6.53,25.61-6.93,52.15-2.11,75.18-.13-17.49,1.12-35.18,4.55-52.41s8.71-34.13,16.3-49.7c-3.5,8.78-6.6,17.76-8.91,26.93-2.44,9.11-4.03,18.48-5.21,27.79-5.54,31.09-4.36,63.96,4.88,95.38-.46-1.12-.86-2.31-1.32-3.5.66,2.38,1.58,4.69,2.38,7.06,3.83,12.21,8.78,24.09,14.92,35.51,5.74,10.1,13.4,18.81,21.65,26.4,1.19,1.45,2.38,2.97,3.56,4.42-3.04-2.11-5.08-2.77-1.12,3.04,8.32,12.48,20.07,23.17,33,32.61,3.17,2.44,6.6,4.62,9.97,7,3.37,2.31,6.93,4.42,10.36,6.73,7.13,4.42,14.32,8.84,21.65,13.4,7.72,4.95,19.54,8.84,32.41,11.35,3.23,1.85,5.21,1.72,7,1.25,2.84.4,5.61.92,8.45,1.25,3.43.53,6.86,1.19,10.3,1.52,3.43.26,6.93.53,10.3.53-3.37-.33-6.8-.66-10.23-.92-3.43-.33-6.93-.79-10.43-1.12-2.57-.4-5.08-.99-7.66-1.45,1.98-.53,4.03-1.19,7.72-.46-23.17-5.15-45.94-14.13-66.6-26.93-20.66-12.74-39.41-28.98-55.31-47.79,2.64,1.65,6.07,4.16,7.59,5.08-3.76-3.04-7.59-6.07-11.16-9.44-9.97-12.41-18.75-25.74-26.07-40,2.57,4.03,5.54,7.52,8.45,10.3-10.43-19.87-18.22-41.25-22.38-63.43-2.11-11.09-3.5-22.38-3.83-33.66-.33-11.35-.13-22.71,1.32-34.06,7.59-42.18,28.18-80.66,57.03-110.17-17.43,14.19-32.41,33.4-42.9,55.45,6.14-14.98,14.06-29.31,23.5-42.57,9.5-13.2,20.66-25.28,33.07-35.84,24.69-21.25,54.98-35.97,86.53-42.38-2.57,1.72-5.35,3.5-8.12,5.28-2.84,1.78-5.54,3.76-8.18,5.61-2.64,1.85-4.95,3.96-7,5.87-.99.99-1.91,1.91-2.71,2.9-.79.99-1.45,1.98-1.91,2.9.33.53,1.78.53,3.5.26,1.78-.2,3.89-.59,5.61-.86,3.5-.59,5.54-.73.66,1.98-4.42,2.57-8.51,5.28-12.48,7.66-3.89,2.64-7.72,4.88-11.22,7.33-7.13,4.69-13.33,9.37-18.68,13.93-10.63,9.17-17.23,18.55-17.23,29.11.2,1.19,2.84.79,6.4-.2,1.85-.46,3.96-.99,6.07-1.65,1.06-.26,2.18-.59,3.3-.92,1.12-.26,2.24-.53,3.37-.79,2.24-.46,4.29-.92,6.2-1.12,1.91-.2,3.56-.26,4.82-.13,2.51.26,3.37,1.39,1.45,3.76-7.06,7.13-19.41,20.13-29.31,36.3-1.78,2.05-3.3,4.42-4.95,6.73-1.58,2.38-2.97,4.88-4.55,7.39-.59.53-.4,1.98-.26,3.76-4.36,9.17-7.72,18.48-10.23,26.8-2.57,8.32-3.96,15.64-5.28,20.86-.4,1.98-.79,3.89-1.25,5.87s-.59,3.96-.99,5.87c-.99,2.05-2.11,3.76-3.43,5.15.99,2.57,1.52,5.15,2.11,7.66-.59,10.76,0,21.45,1.78,31.88.07,6.01.2,12.15,1.12,18.09.86-.4,1.72-1.72,2.9-.92,1.78,6.4,4.36,12.54,6.93,18.68,2.9,6.01,5.81,11.95,9.44,17.56.92,2.64,1.85,5.15,2.57,7.66.4,1.25.66,2.57.99,3.83.33,1.25.59,2.51.86,3.76,7.72,3.43,16.11,11.82,26.01,20.4,9.77,8.71,21.39,17.16,32.08,21.85l.13-.26c10.36,5.35,21.39,9.7,32.94,12.74,1.72,1.19,3.37,2.51,4.88,3.96,3.23-.66,6.34-.33,7.85-.66,9.24,2.51,17.29,4.88,25.68,6.73,1.52-.59,4.36-3.43,7.46-3.56,3.17.07,6.27-.26,9.37-.46,3.04-.33,6.07-.86,8.98-1.25,6.93-.92,13.99-1.91,20.99-3.63,23.7-5.35,46.2-15.64,66.14-30.03,1.25.26,2.31,1.12,3.3,1.91.99-1.85,2.51-3.56,4.16-5.15.79-.79,1.65-1.52,2.38-2.31s1.32-1.58,1.78-2.38c-.13.79,0,1.45.53,1.85,1.58-2.44,3.04-4.22,4.36-5.68,1.32-1.52,2.57-2.57,3.89-3.63,1.32-.99,2.71-1.98,4.16-3.17,1.45-1.19,3.1-2.57,4.88-4.49,1.32-1.98,1.52-4.49,2.57-6.6.79-.86,1.45-1.78,2.18-2.64,2.77-1.72,5.28-3.63,7.26-5.94,2.05-2.31,3.89-4.75,5.35-7.46.79-1.32,1.45-2.71,2.18-4.09s1.25-2.84,1.91-4.29c.66-1.45,1.25-2.97,1.91-4.42.59-1.52,1.19-3.04,1.78-4.62,6.2-11.88,11.22-24.55,14.65-37.82,1.19-5.28,2.9-8.84,4.49-12.15.86-1.65,1.65-3.17,2.51-4.82.79-1.65,1.52-3.3,2.18-5.21" />
          <path
            class="cls-1"
            d="M160.2,397.1c8.58,7.79,17.95,14.72,28.05,20.73-1.45-.66-2.84-1.32-4.22-1.91-1.39-.59-2.77-1.32-4.09-1.98s-2.71-1.32-4.03-1.98c-1.25-.73-2.51-1.52-3.76-2.24-2.51-1.52-4.75-3.3-6.73-5.41-2.05-1.98-3.76-4.49-5.21-7.26" />
          <path
            class="cls-1"
            d="M166.27,136.7c2.44-.26,4.82-.73,7.33-1.19,2.44-.53,4.88-1.25,7.39-1.98-23.23,13-42.9,32.54-56.37,56.24l-.26-.13c4.88-9.83,13.33-20.4,21.85-29.11,8.45-8.91,16.7-16.44,20.07-23.76" />
          <path class="cls-1" d="M138.35,374.79c.53.13,1.12.33,1.72.53v.07c-.59-.07-1.19-.26-1.78-.66" />
          <path
            class="cls-1"
            d="M200,66.27c1.12-.33,2.24-.59,3.43-.86-4.22,1.52-8.45,2.9-12.54,4.69-4.16,1.58-8.18,3.5-12.21,5.28,6.2-3.56,13.53-6.73,21.39-9.04" />
          <path
            class="cls-1"
            d="M294.39,64.95c2.24.26,4.42.73,6.6,1.19,2.18.46,4.42.86,6.6,1.39,4.36,1.19,8.78,2.11,13,3.56,8.65,2.51,17.03,5.94,25.28,9.57,20.46,11.02,38.09,26.14,50.76,43.43-26.8-28.71-62.51-50.03-102.24-59.14" />
          <path
            class="cls-1"
            d="M214.79,116.83c1.39-.13,2.84-.26,4.22-.33h4.29c2.84-.07,5.74.2,8.51.26-2.77.4-5.48.66-8.18,1.25l-4.09.79c-1.32.26-2.64.66-4.03.99.79-1.12-.4-2.11-.79-2.97" />
          <path
            class="cls-1"
            d="M135.12,101.72c1.45-1.06,2.9-2.11,4.36-3.17-3.37,3.23-6.4,6.86-9.44,10.3.92-1.52,3.43-4.62,5.08-7.13" />
          <path
            class="cls-1"
            d="M273.73,118.35c-1.98-.46-3.96-.73-5.94-.99-1.98-.33-3.96-.66-5.94-.79,2.44-.53,4.82-.99,7.26-1.85,1.19,1.39,2.77,2.51,4.62,3.63" />
          <path
            class="cls-1"
            d="M332.01,137.82c2.31,1.52,4.55,3.04,6.67,4.55,2.05,1.65,4.16,3.17,6.07,4.95-5.21-3.5-10.69-6.93-16.37-9.83,1.72-.07,3.1-.2,3.56.33" />
        </svg>
      </div>
      <img
        *rxIf="data | getVariantAssetForCard | async as variantAsset; else brandName"
        appImage
        class="product-card-image"
        [asset]="variantAsset"
        src=""
        alt="" />
      <ng-template #brandName>
        <div
          *rxIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
          class="product-card-brand"
          [style.color]="viewModel.headerTextColor$ | async">
          {{ brand }}
        </div>
      </ng-template>
    </div>

    <div
      #productCardName
      class="product-card-name"
      appPrintCardScaleDownText
      [maxHeightInPx]="45"
      [maxWidthInPx]="212"
      [adjustLineHeight]="false"
      [startScalingAfterNMillisecondsAfterViewInit]="
        (viewModel.viewingInLiveView$ | async) ? 0 : startScalingAfterNMillisecondsAfterViewInit
      "
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      [style.color]="viewModel.headerTextColor$ | async">
      <div>
        {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely }}
      </div>
    </div>

    <div
      *rxIf="viewModel.hasMainProperties$ | async"
      class="properties-container"
      [style.color]="viewModel.bodyTextColor$ | async">
      <ng-container *rxFor="let property of viewModel.mainProperties$ | async; last as last">
        <div class="property-container">
          <div
            class="value"
            appPrintCardScaleDownText
            [maxHeightInPx]="14"
            [startScalingAfterNMillisecondsAfterViewInit]="
              (viewModel.viewingInLiveView$ | async) ? 0 : startScalingAfterNMillisecondsAfterViewInit
            "
            [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
            {{ property.title }}: {{ property.value }}
          </div>
          <div *rxIf="!last">|</div>
        </div>
      </ng-container>
    </div>

    <div
      *ngIf="(viewModel.hasBadges$ | async) || (viewModel.hasLabel$ | async)"
      class="product-card-badge-and-label-container">
      <app-label-inflator
        class="print-card-label"
        [columnLabel]="false"
        [labelComponentInterface]="data"
        [reset]="false">
      </app-label-inflator>
      <img
        *rxFor="let variantBadge of data | printCardBadges"
        appImage
        class="product-card-badge"
        [asset]="variantBadge?.image"
        alt="badge"
        src="" />
    </div>

    <div
      class="product-card-description"
      [class.description-text-6-lines]="
        (viewModel.badgeOrLabelVisible$ | async) && (viewModel.hasTotalTerpenesAndPresentTerpenes$ | async)
      "
      [class.description-text-8-lines]="
        (!(viewModel.badgeOrLabelVisible$ | async) &&
          (viewModel.exclusiveOrOfTotalTerpenesAndPresentTerpenes$ | async)) ||
        ((viewModel.badgeOrLabelVisible$ | async) && !(viewModel.hasTotalTerpenesOrPresentTerpenes$ | async))
      "
      [class.description-text-9-lines]="
        !(viewModel.badgeOrLabelVisible$ | async) && !(viewModel.hasTotalTerpenesOrPresentTerpenes$ | async)
      "
      [style.color]="viewModel.bodyTextColor$ | async">
      <app-print-card-description-container
        [cardData]="viewModel.cardData$ | async"
        [bodyTextColor]="viewModel.bodyTextColor$ | async"></app-print-card-description-container>
    </div>
  </div>

  <div class="bottom-container" [style.color]="viewModel.bodyTextColor$ | async">
    <div class="terpenes-container">
      <div *rxIf="viewModel.koanVisibleTotalTerpenes$ | async as property" class="total-terpene-container">
        <div class="title">{{ property.title }}:</div>
        <div
          class="value"
          appPrintCardScaleDownText
          [maxHeightInPx]="16"
          [startScalingAfterNMillisecondsAfterViewInit]="
            (viewModel.viewingInLiveView$ | async) ? 0 : startScalingAfterNMillisecondsAfterViewInit
          "
          [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
          {{ property.value }}
        </div>
      </div>
      <div
        *rxIf="viewModel.koanVisiblePresentTerpenes$ | async as presentTerpenes"
        class="present-terpenes-container"
        appPrintCardScaleDownText
        [maxHeightInPx]="22"
        [startScalingAfterNMillisecondsAfterViewInit]="
          (viewModel.viewingInLiveView$ | async) ? 0 : startScalingAfterNMillisecondsAfterViewInit
        "
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
        {{ presentTerpenes.value }}
      </div>
    </div>

    <div
      class="price-and-size-container"
      [ngStyle]="{
        'grid-template-columns': (viewModel.atLeastOneGridVariantOnSale$ | async) ? '0fr auto 1fr' : '1fr auto 1fr'
      }">
      <div class="empty-space"></div>
      <div class="product-card-price-container">
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel"
          [includeLineThroughOnLeadingTextOriginalPriceWithSale]="false"
          [ignoreStylingForSaleText]="false">
        </app-column-primary-price>
      </div>
      <div *rxIf="viewModel.productSize$ | async as size" class="product-card-size">
        {{ size }}
      </div>
    </div>
  </div>
</div>
